import React from "react";
import styles from "./Tooltip.module.scss";
import * as RadixTooltip from "@radix-ui/react-tooltip";

/**
 *
 * Tooltip
 *
 */
const Tooltip = ({ children, color = "bg-black", text = "", ...props }) => {
  return (
    <RadixTooltip.Provider>
      <RadixTooltip.Root>
        <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
        <RadixTooltip.Portal>
          <RadixTooltip.Content
            className={`${color} text-white p-2 rounded-md shadow-md z-[150] data-[state=delayed-open]:data-[side=top]:animate-slideDownAndFade data-[state=delayed-open]:data-[side=right]:animate-slideLeftAndFade data-[state=delayed-open]:data-[side=left]:animate-slideRightAndFade data-[state=delayed-open]:data-[side=bottom]:animate-slideUpAndFade`}
            sideOffset={5}
          >
            {text}
            <RadixTooltip.Arrow className={styles.arrow} color="white" />
          </RadixTooltip.Content>
        </RadixTooltip.Portal>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  );
};

export default Tooltip;
